import { OtherExplanationSchema } from '@Containers/OtherExplanations/validators';
import { z } from 'zod';
import { OverviewSchema } from '../Overview/validators';

export const EsgDataPlatformSchema = z.object({
  otherDescriptions: z.array(OtherExplanationSchema).optional(),
  esgDataPlatform: OverviewSchema.optional(),
});
